const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const CONSENT_KEY = "mst_cookie_consent";

let gaLoaded = false;

export const getConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

export const setConsent = (value) => {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* no-op */ }
  if (value === "all") initAnalytics();
};

export const initAnalytics = () => {
  if (gaLoaded || !GA_ID || getConsent() !== "all") return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
  gaLoaded = true;
};

// Never pass PII (names, emails, phones, application answers) into params.
export const trackEvent = (name, params = {}) => {
  if (getConsent() !== "all" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};
